<template>
    <div>
        <input v-model="url" ref="clone" @focus="$event.target.select()" type="text" readonly>
        <button @click="preCopy">Copy URL</button>
    </div>
</template>

<script>
export default {
    name: "CopyUrl",
    data() {
        return {
            url: '',
        }
    },
    mounted() {
        this.url = window.location.href;
    },
    methods: {
        preCopy() {
            this.url = window.location.href;
            this.$nextTick(() => {
                this.copy();
            })
        },
        copy() {
            this.$refs.clone.focus();
            document.execCommand('copy');
        }
    }
}
</script>

<style scoped>

</style>
